function makeDebugLog(debugMode=true){
    let debug = debugMode;
    function debugLog(any){
        if(debug==true){
            console.log(any)
        };
    }
    return debugLog;
}
export default makeDebugLog;